import {LHRAudit} from "@/pages/pagespeed/types.ts";

interface FilmstripProps {
  audits: Record<string, LHRAudit>;
}
export const Filmstrip = ({audits}: FilmstripProps) => {
  const thumbnails = audits["screenshot-thumbnails"];
  if (thumbnails && thumbnails.details) {
    // @ts-expect-error legacy
    const frames = thumbnails.details.items.map((i) => (
      <div className="frame" key={"t" + i.timing}>
        <img src={i.data} title={i.timing + "ms"} />
        <span>{(i.timing / 1000).toFixed(1) + "s"}</span>
      </div>
    ));
    return (
      <div key="vis" className="mb-5">
        <h5 className="my-4">Speed Visualization</h5>
        <div className="pagespeed-filmstrip">{frames}</div>
      </div>
    );
  }
  return null;
};
